import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import {utils, WorkBook, write} from 'xlsx';
import {saveAs} from 'file-saver';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GridOptions} from 'ag-grid/main';


import {
  AgGridUtility,
  APP_DATE_FORMAT,
  AUDIT_BTN,
  AUDIT_ENTITY_COLUMN_DEFS,
  AUDIT_ENTITY_ID,
  AUDIT_ENTITY_TYPE,
  AUDIT_PAGE_TITLE,
  CommonUtility,
  DataService,
  DateUtility,
  DOUBLE_ROW_HEADER,
  EDIT_BTN,
  FROMDT_GT_TODT,
  MIN_CHAR_SEARCH_LENGTH,
  OVERDUE_BTN,
  Role,
  ServerConstantsService,
  SINGLE_ROW_HEADER,
  Task,
  TaskHistory,
  TaskSearch,
  WpPerson,
  WpProvider,
  WpReferral
} from '../shared';
import {Subject} from 'rxjs';
import {ReferenceTableService} from '../reference-table.service';
import {NotificationsService} from 'angular2-notifications';
import {ProviderService} from '../provider-management/provider-management.service';

export type EntityResponseType = HttpResponse<Task>;


@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class TaskComponent implements OnInit {
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;
  searchCriteria: string;
  currentSearch: String;
  noData: Boolean = false;
  task: Task;
  tasks: Task[];
  tasksCorrected: Task[];
  taskHistory: TaskHistory[];
  programs: any[];
  taskStatus: any[];
  taskTypes: any[];
  taskTypesCopy: any[];
  private _danger = new Subject<string>();
  errorMessage: string;
  programMap: any;
  taskStatusMap: any;
  taskTypesMap: any;
  serverConstants: any;
  userActionNotificationsMap: any;
  elasticSuggestions = new BehaviorSubject<any>(null);
  elasticSuggestionsUser = new BehaviorSubject<any>(null);
  results: any = [];
  suggestions: any = [];
  suggestionsUser: any = [];
  taskSearch: TaskSearch;
  taskDueDateFrom: any;
  taskDueDateTo: any;
  errorFromDateField: any;
  errorToDateField: any;
  completionDtSw: any = 'N';
  APP_DATE_FORMAT = APP_DATE_FORMAT;
  modalReference: any;
  closeResult: string;
  noHistoryData: Boolean = false;
  historyTasks: Task[] = [];
  firstHistoryTask: Task;
  completeTaskYes: Boolean = false;
  completeTaskNo: Boolean = false;
  reAssignYes: Boolean = false;
  reAssignNo: Boolean = false;
  workers: any[];
  reAssignedWorker: string;
  isSubmitEnabled: Boolean = false;
  isTaskOpen: Boolean = false;
  isTaskInprogress: Boolean = false;
  minDate: any;
  errorEndDateField: string = null;
  errorMoreThanSixMonthsInterval: any;
  errorMessageMoreThanSixMonthsInterval = 'The from and to dates must be within a 6 month period.';

  assignedTo: any;
  county: any;
  columnDefs: any;
  auditColumnDefs: any;
  context: any;
  taskTypesJson: any;
  taskTypesJsonForExcel: any;
  taskStatusJson: any;
  countiesJson: any;
  countiesMap: any;
  counties: any;

  countiesDropdown: any[] = [];

  assignedToJson: any;
  assignedToMap: any;
  assignedToDD: any;
  providers: Map<any, string> = new Map<any, string>();
  columnDefsIndv: any;
  programsJson: any;
  gridOptions: GridOptions;
  gridApi;
  gridApiIndv;

  dropdownSettings: any = {};
  taskStatusMulti: Array<any>;

  valArray: any[];
  // SSN Search
  ssnValue;

  userCounties: any;
  countiesArr: Array<any> = [];
  sharedData: any;
  isFocused = false;
  tabToNextCell: any;

  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('taskStartDtDp') taskStartDtDp: ElementRef;
  @ViewChild('resultList') resultList: ElementRef;
  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('all1') all1: ElementRef;
  @ViewChild('pdfIcon') pdfIcon: ElementRef;

  ws: any;
  assignedUser: any;
  isStateWorker = true;
  roles: Role[];

  loaderUserFocus = false;
  loaderSearchFocus = false;
  loaderIndivFocus = false;
  loaderPfdFocus = false;
  firstTime: Boolean = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private titleService: Title,
    private modalService: NgbModal,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private providerService: ProviderService,
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
  }

  ngOnInit() {

    this.sharedData = this.dataService.getSharedDataObject();
    if (this.sharedData.get('IS_ALL_PAGES_READ_ONLY') === true && this.sharedData.get('IS_ALL_PAGES_READ_ONLY') !== undefined) {
      this.dataService.revertAllPagesReadOnly();
      this.dataService.addValueToSharedDataMap('IS_ALL_PAGES_READ_ONLY', false);
    }
    this.countiesArr = this.sharedData.get('userCounties');
    if (this.countiesArr === undefined) {
      this.countiesArr = JSON.parse(sessionStorage.getItem('userCounties'));
    }
    sessionStorage.setItem('userCounties', JSON.stringify(this.countiesArr));
    this.getRefTableData();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false,
    };
    this.dataService.removeValueFromSharedDataMap('selectedEPForComponent');
    this.taskStatusMulti = [];

    //Remove reference from latest Appointment task, in case it is still there
    this.dataService.removeValueFromSharedDataMap('appTaskId');
    this.dataService.removeValueFromSharedDataMap('UNIVERSE_SEARCH');
    this.searchCriteria = 'all';
    this.task = new Task();
    this.task.programCd = 'FS';
    this.taskSearch = new TaskSearch();

    if (this.dataService.getSharedDataObject().get('initTaskSearchSw') === 'Y') {
      this.initializeSearch();
    }

    this.getColumnDefinitions();
    this.getAuditColumnDefs();

    this.providers = this.dataService.getSharedDataObject().get('providers');
    if (this.providers === null || this.providers === undefined || this.providers.size === 0) {
      this.loadProviders();
    }

    this.roles = this.sharedData.get('roles');
    this.setAssignedUserAccess();

    this.taskDueDateTo = this.dateUtil.convertDateFromServer(this.dateUtil.getFormattedSystemDateFromModelForServer());

    if(this.dataService.getSharedDataObject().get('overdueTasks')) {
      this.taskDueDateFrom = "2015/01/01";
    } else {
      this.taskDueDateFrom = this.dateUtil.convertDateFromServer(this.getFromDate());
    }

    console.log('this.taskDueDateTo: ' + this.taskDueDateTo);
    console.log('this.taskDueDateFrom: ' + this.taskDueDateFrom);
  }

  setAssignedUserAccess() {
    this.isStateWorker = true;
    for (const role of this.roles) {
      if (role.id === 5) {
        this.isStateWorker = false;
        break;
      }
    }
  }

  downloadPDFJsonKeydown(event) {
    if ( event.keyCode === 32 || event.keyCode === 13) {
      this.downloadPDFJson();
    }
  }

  downloadPDFJson() {
    const doc = new jsPDF('p', 'mm', 'a1');
    const col = [ 'Task Type', 'Client Name', 'Creation Date', 'Due Date', 'Completion Date', 'Assigned To', 'County', 'Task Status'];
    const rows = [];
    const rowCountModNew = this.tasks;

    rowCountModNew.forEach(element => {
      const taskStatusMap = this.taskStatusJson;
      const taskStatusCode = element.taskStatus;
      const taskStatus = taskStatusMap[taskStatusCode];
      const taskTypesMap = this.taskTypesJson;
      const taskTypeCode = element.taskType;
      const taskType = taskTypesMap[taskTypeCode];
      let assUser = '';
      if (element.assignedToInd === 'C') {
        assUser = element.assignedUserStr;
      } else if (element.assignedToInd === 'P') {
        assUser = this.providers.get(element.assignedTo);
      }
      if(element.taskCompletionDt == null)
      {
       element.taskCompletionDt = ' ' ;
      }
      else
      {
      element.taskCompletionDt = this.dateUtil.convertDateFromServerForExcelPDF(element.taskCompletionDt);
      }
      const row = [ taskType, element.wpPerson.firstName + ' ' + element.wpPerson.lastName, this.dateUtil.convertDateFromServerForExcelPDF(element.createdDate.trim().split('T')[0]), this.dateUtil.convertDateFromServerForExcelPDF(element.taskDueDt), element.taskCompletionDt, assUser,
        this.countiesMap.get(element.serviceCounty + ''), taskStatus];
      rows.push(row);

    });

    doc.text('Task List', 13, 10);
    doc.autoTable(col, rows);
    doc.save('TaskList.pdf');
  }


  downloadExcelKeydown(event) {
    if (  event.keyCode === 32 || event.keyCode === 13) {
      this.downloadExcel();
    }
  }

  downloadExcel() {
    const content = this.all1.nativeElement;
    const ws_name = 'TaskSheet';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };

    this.ws = utils.table_to_sheet(content);

    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = this.ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
      }
      return buf;
    }
    saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), 'exported.xlsx');
  }

  ssnSearch() {
    if (this.ssnValue !== undefined && this.ssnValue.length === 9) {
      this.dataService.addValueToSharedDataMap('SSN_SEARCH', this.ssnValue);
      this.dataService.addValueToSharedDataMap('UNIVERSE_SEARCH', true);
      let personProvider={conversionStat:null,emciId:null};
      this.dataService.addValueToSharedDataMap('personProvider',personProvider);
      this.router.navigate(['/universe/personSummary']);
    } else {
      this.notificationService.error('Universe Search', 'Please provide valid SSN');
    }
  }

  focus() {
    this.isFocused = true;
  }

  onSelectAll(items: any) {
    for (const item of items) {
      this.onItemSelect(item);
    }
    this.isFocused = false;
  }


  onItemDeselect(deselectStatus) {

    this.taskStatusMulti.forEach((status, index) => {
      if (status === deselectStatus) { this.taskStatusMulti.splice(index, 1); }
    });
    event.stopPropagation();
  }

  onItemSelect(item: any) {
    this.isFocused = false;
  }

  getColumnDefinitions() {
    this.columnDefs = [
      //  {
      //    headerName: 'Task ID',
      //   field: '',
      //    cellRenderer: this.getTaskIdAudit,
      //    cellStyle: {'text-align': 'center !important'},
      //    width: 100,
      //  },
      {

        headerName: 'Task Type',
        field: '',
        refData: this.taskTypesJson,
        cellRenderer: this.getTaskTypeLink,
        width: 240,
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
        valueGetter: this.getTaskType,
      }
      ,
      {
        headerName: 'Client Name',
        colId: 'wpPerson.firstName&wpPerson.lastName',
        valueGetter: function getName(params) {
          return params.data.wpPerson.firstName + ' ' + params.data.wpPerson.lastName;
        },
        width: 150,
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
        suppressFilter: false,
      },
      {
        headerName: 'Creation Date',
        field: 'createdDate',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 120,
      },
      {
        headerName: 'Due Date',
        field: 'taskDueDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatDates,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 115,
      },
      {
        headerName: 'Completion Date',
        field: 'taskCompletionDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatDates,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 130,
      },
      {
        headerName: 'Assigned To',
        field: 'assignedTo',
        width: 110,
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
        valueGetter: this.getAssignedTo,
      },
      {
        headerName: 'Service County',
        field: '',
        width: 120,
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
        valueGetter: this.getServiceCounty,
      },
      {
        headerName: 'Task Status',
        field: 'taskStatus',
        refData: this.taskStatusJson,
        width: 100,
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
      },
      {
        headerName: 'Overdue',
        field: '',
        cellRenderer: this.isTaskOverDue,
        // cellStyle: {'text-align': 'center !important'},
        width: 104,
        suppressFilter: true,
        suppressSorting: true,
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        // cellStyle: {'text-align': 'center !important'},
        width: 90,
        suppressFilter: true,
        suppressSorting: true,
      },
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if ( nextCell == null || nextCell.column.colDef.headerName === 'Action' ||
        nextCell.column.colDef.headerName === 'Task ID' || nextCell.column.colDef.headerName === 'Task Type') {
        return;
      } else {
        return nextCell;
      }
    };

    this.columnDefsIndv = [
      {
        headerName: 'Client ID',
        field: 'personId',
        cellRenderer: this.getPersonIdLink,
        width: 145,
        //cellStyle: {'text-align': 'center !important'},
      },
      {
        headerName: 'Name',
        colId: 'firstName&lastName',
        valueGetter: function getName(params) {
          return params.data.firstName + ' ' + params.data.lastName;
        },
        width: 220,
        autoHeight: true,
        //cellStyle: {'white-space': 'normal', 'text-align': 'center !important'},
        cellStyle: { 'white-space': 'normal' },
        suppressFilter: false,
      },
      {
        headerName: 'SSN',
        field: 'ssn',
        width: 200,
        autoHeight: true,
        //cellStyle: {'white-space': 'normal','text-align': 'center !important'},
        cellStyle: { 'white-space': 'normal' },
        suppressFilter: false,
        valueFormatter: this.agGridUtility.formatSsn,
        //cellRenderer: this.getSsnCell,
      },
      {
        headerName: 'Date of Birth',
        field: 'dobDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatDobDates,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 170,
        //cellStyle: {'text-align': 'center !important'},
      },
      {
        headerName: 'Program',
        field: 'programCd',
        width: 200,
        autoHeight: true,
        //cellStyle: {'white-space': 'normal', 'text-align': 'center !important'},
        cellStyle: { 'white-space': 'normal' },
        suppressFilter: false,
        valueGetter: function getProgram(params) {
          const that = params.context.component;
          return that.programMap.get(params.data.programCd);
        },
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButtonIndv,
        //cellStyle: {'text-align': 'center !important'},
        width: 170,
        suppressFilter: true,
        autoHeight: true,
        cellStyle: (params) => {
          console.log(params);
          if (params.data.id !== null || params.data.id !== undefined) {
            return { lineHeight: '23px' };
          } else {
            return { lineHeight: '26px' };
          }
        }
      },
    ];

    this.context = {
      component: this,
    };
  }

  getAuditColumnDefs() {
    this.auditColumnDefs = [
      {
        headerName: 'Task ID',
        field: 'id',
        tooltipField: 'id'
      },
      {
        headerName: 'Task Type',
        field: 'taskType',
        refData: this.taskTypesJson,
        tooltip: (params) => {
          const taskTypesMap = params.context.taskTypesJson;
          const taskTypeCode = params.data.taskType;
          const taskType = taskTypesMap[taskTypeCode];
          return taskType;
        }
      },
      {
        headerName: 'Task Status',
        field: 'taskStatus',
        refData: this.taskStatusJson,
        tooltip: (params) => {
          const taskStatusMap = params.context.taskStatusJson;
          const taskStatusCode = params.data.taskStatus;
          const taskStatus = taskStatusMap[taskStatusCode];
          return taskStatus;
        }
      },
      {
        headerName: 'Modified By',
        field: 'createdBy',
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'lastModifiedDate',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      }
    ];
  }

  getTaskType(params) {
    const task: Task = params.data;
    const that = params.context.component;

    return that.taskTypesMap.get(task.taskType);
  }

     getTaskTypeForExcel(element) {
    const task: Task = element;
    return this.taskTypesMap.get(task.taskType);
  }

  getAssignedTo(params) {
    const task: Task = params.data;
    const that = params.context.component;

    if (task.assignedToInd === 'C') {
      return task.assignedUserStr;
    } else if (task.assignedToInd === 'P') {
      return that.providers.get(task.assignedTo);
    }
  }

  getServiceCounty(params) {
    const task: Task = params.data;
    const that = params.context.component;

    return that.countiesMap.get(task.serviceCounty + '');
  }

  getEditButton(params) {
    const that = params.context.component;
    const divRow = document.createElement('div');
    divRow.setAttribute('class', 'row');

    // Edit Button
    const element = document.createElement('a');
    const image = EDIT_BTN;

    //element.className = 'edit-button';
    element.innerHTML = image;
    element.addEventListener('click', () => {
      //that.setInitSearchCriteria();
      that.dataService.addValueToSharedDataMap('referralId', params.data.wpReferral.id);
      that.dataService.addValueToSharedDataMap('wpPersonId', params.data.wpPerson.id);
      that.dataService.addValueToSharedDataMap('task', params.data);
      that.getUserInfoForTaskId(params.data, params.data.wpReferral.id, params.data.wpPerson.id,'task');
      // that.router.navigate(['/task/createTask']);
    });

    // START ADA
    element.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.dataService.addValueToSharedDataMap('referralId', params.data.wpReferral.id);
        that.dataService.addValueToSharedDataMap('wpPersonId', params.data.wpPerson.id);
        that.dataService.addValueToSharedDataMap('task', params.data);
        that.getUserInfoForTaskId(params.data, params.data.wpReferral.id, params.data.wpPerson.id,'task');
        // that.router.navigate(['/task/createTask']);
        //that.navigateOnRefferalDecision(params.data.taskType);
      }
      else if(event.keyCode == 9){
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }
    });
    element.setAttribute('tabindex', '0');
    // END ADA

    const divCol1 = document.createElement('div');
    divCol1.setAttribute('class', 'col-2 right-margin-1');

    divCol1.appendChild(element);

    // Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.TasksEntity');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Task History');
      that.getUserInfoForTaskId(params.data, params.data.wpReferral.id, params.data.wpPerson.id,'audit');
      
      // Pass Floating Elements here...
      // that.dataService.addValueToSharedDataMap('floatingData', that.auditElements);
    });

    // START ADA
    auditElement.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.TasksEntity');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Task History');
        that.getUserInfoForTaskId(params.data, params.data.wpReferral.id, params.data.wpPerson.id,'audit');
        //that.navigateOnRefferalDecisionAudit(params.data.taskType);
      } else {
        return;
      }
    });
    auditElement.setAttribute('tabindex', '0');
    // END ADA

    const divCol2 = document.createElement('div');
    divCol2.setAttribute('class', 'col-1');
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);

    return divRow;
  }

  navigateOnRefferalDecision(taskType) {
    if (taskType === 'RR') {
      this.dataService.addValueToSharedDataMap('UNIVERSE_SEARCH', true);
      this.router.navigate(['/universe/create']);
    } else {
      this.router.navigate(['/task/createTask']);
    }
  }
  navigateOnRefferalDecisionAudit(taskType) {
    if (taskType === 'RR') {
      this.dataService.addValueToSharedDataMap('UNIVERSE_SEARCH', true);
      this.router.navigate(['/universe/taskSummary/auditHistory']);
    } else {
      this.router.navigate(['/task/taskSummary/auditHistory']);
    }
  }

  getEditButtonIndv(params) {
    const that = params.context.component;
    const element = document.createElement('button');
    //const image = "<img src=\".../../" + EDIT_BTN + "\" width=\"28\" height=\"23\"/>";

    element.innerHTML = 'SEARCH TASKS';
    element.type = 'button';
    element.className = 'btn btn-outline-primary btn-sm';
    element.setAttribute('style', 'padding: 0.1rem 0.5rem; height: 1.7em; line-height: 0.5; font-size: 12px');
    // element.setAttribute('height', 2em)
    element.addEventListener('click', () => {
      that.searchTasksForIndv(params.data);
    });

    // START ADA
    element.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.searchTasksForIndv(params.data);
        that.focusPdfIcon(event);
      } /*else if ((!event.shiftKey && event.keyCode === 9) && (params.rowIndex === (that.results.length - 1))) {
        event.preventDefault();
        if (that.tasks.length > 0) {
          //that.focusSearchSummary(event);
          that.focusPdfIcon(event);
        } else {
          that.focusing(event);
        }
      }*/
    });
    element.setAttribute('tabindex', '0');
    // END ADA
    return element;
  }

  getTaskTypeLink(params) {
    const that = params.context.component;
    const taskTypeName = that.convertCode(that.taskTypesMap, params.data.taskType);

    if (params.data.taskStatus === 'CO') {
      const element = document.createElement('div');
      element.innerHTML = taskTypeName;
      element.setAttribute('tabindex', '0');
      return element;

    } else {
      const element = document.createElement('a');
      element.innerHTML = taskTypeName;
      element.addEventListener('click', () => {
        that.updateTaskStatus(params.data);
        that.routeSelection(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
      });

      // START ADA
      element.addEventListener('keydown', (event) => {
        if (event.keyCode === 13 || event.keyCode === 32) {
          that.updateTaskStatus(params.data);
          that.routeSelection(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
        } else {
          return;
        }
      });
      element.setAttribute('tabindex', '0');
      // END ADA
      return element;
    }
  }

  // Commenting out for Future Use

   getTaskIdAudit(params) {
     const that = params.context.component;
     const element = document.createElement('p');
     element.innerHTML = params.data.id;
  //   element.addEventListener('click', () => {
  //     that.dataService.addValueToSharedDataMap('component', params.context.component);
  //     that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
  //     that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.TasksEntity');
  //     that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
  //     that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Task History');
  //     that.getUserInfoForTaskId(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
  //   });

  //   element.addEventListener('keydown', (event) => {
  //     if (event.keyCode === 13 || event.keyCode === 32) {
  //       that.dataService.addValueToSharedDataMap('component', params.context.component);
  //       that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
  //       that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.TasksEntity');
  //       that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
  //       that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Task History');
  //       that.getUserInfoForTaskId(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
  //     }
  //     else {
  //       return;
  //     }
  //   });
  //   element.setAttribute("tabindex", "0");

     return element;
   }

  getPersonIdLink(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    element.innerHTML = params.data.personId;
    element.addEventListener('click', () => {
      that.goToEnrollmentSummary(params.data);
      const person = new WpPerson();
      const referral = new WpReferral();
      const indvTask = new Task();
      let taskSearch1 = new TaskSearch();

      person.id = params.data.personId;
      referral.id = params.data.referralId;
    indvTask.wpPerson = person;
    indvTask.wpReferral = referral;
    taskSearch1.task = indvTask;
    that.dataService.addValueToSharedDataMap("taskSearch", taskSearch1);
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.goToEnrollmentSummary(params.data);
        const person = new WpPerson();
      const referral = new WpReferral();
      const indvTask = new Task();
      let taskSearch1 = new TaskSearch();

      person.id = params.data.personId;
      referral.id = params.data.referralId;
    indvTask.wpPerson = person;
    indvTask.wpReferral = referral;
    taskSearch1.task = indvTask;
    that.dataService.addValueToSharedDataMap("taskSearch", taskSearch1);
      }
    });
    element.setAttribute('tabindex', '0');
    return element;
  }


  isTaskOverDueForPDF(params) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateParts = params.taskDueDt.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const taskDueDt = new Date(year, month, day);
    const icon = OVERDUE_BTN;
    let element = null;

    if (params.data.taskStatus !== 'CO'
      && today > taskDueDt) {
      element = document.createElement('span');
      element.innerHTML = icon;
      return element;
    } else {
      return null;
    }
  }
  isTaskOverDue(params) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateParts = params.data.taskDueDt.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const taskDueDt = new Date(year, month, day);
    const icon = OVERDUE_BTN;
    let element = null;

    if (params.data.taskStatus !== 'CO'
      && today > taskDueDt) {
      element = document.createElement('span');
      element.innerHTML = icon;
      return element;
    } else {
      return null;
    }
  }

  getSsnCell(params) {
    const that = params.context.component;
    const ssnFormatted = that.agGridUtility.formatSsn(params);
    const element = document.createElement('div');

    element.innerHTML =
      ' <input type="password" class="form-control"  id="field_ssn" ' +
      ' name="ssn" value ="' + ssnFormatted + '" disabled style="width: 116px;"> ';

    element.addEventListener('click', (event) => {
      const input: any = event.target;
      if (input.type === 'text') {
        input.type = 'password';
      } else {
        input.type = 'text';
      }
    });
    element.addEventListener('keydown', (event) => {
      const input: any = event.target;
      if (input.type === 'text') {
        input.type = 'password';
      } else {
        input.type = 'text';
      }
    });
    element.setAttribute('tabindex', '0');
    return element;
  }

  initializeSearch() {
    this.taskStatusMulti = [];
    this.taskDueDateFrom = this.dataService.getSharedDataObject().get('taskDueDateFrom');
    this.taskDueDateTo = this.dataService.getSharedDataObject().get('taskDueDateTo');
    this.task.taskType = this.dataService.getSharedDataObject().get('taskType');
    this.task.programCd = this.dataService.getSharedDataObject().get('programCd');
    this.completionDtSw = this.dataService.getSharedDataObject().get('completionDtSw');

    if (this.dataService.getSharedDataObject().get('taskStatus') != null) {
      for (const status of this.dataService.getSharedDataObject().get('taskStatus').split(',')) {
        for (const statusDef of this.taskStatus) {
          if (status == statusDef.value) {
            this.taskStatusMulti.push({ value: statusDef.value, name: statusDef.name });
          }
        }
      }
    }

    this.searchCriteria = this.dataService.getSharedDataObject().get('searchCriteria');
    this.currentSearch = this.dataService.getSharedDataObject().get('currentSearch');
    this.assignedTo = this.dataService.getSharedDataObject().get('assignedTo');
    this.county = this.dataService.getSharedDataObject().get('county');

    if (this.searchCriteria === 'all') {
      this.searchTask();
    } else {
      this.elasticSearch(this.currentSearch, this.elasticSuggestions);
      this.elasticSuggestions.subscribe((value) => {
        if (value === null) { return; }
        this.results = [];
        for (const s of value) {
          if (s.id === this.dataService.getSharedDataObject().get('elasticSearchIndvId')) {
            this.results.push(Object.assign({}, s));
            break;
          }
        }
      });
    }
    this.dataService.addValueToSharedDataMap('initTaskSearchSw', 'N');
  }

  radioChange(event) {
    this.clearSearch();
    this.tasks = undefined;
    this.task = new Task();
    this.task.programCd = 'FS';
    this.assignedUser = null;
    this.taskSearch = new TaskSearch();
    this.noData = false;
    this.currentSearch = '';
    this.results = undefined;
    this.dataService.addValueToSharedDataMap('initTaskSearchSw', 'N');
    this.taskStatusMulti = [];
  }


  radioCompleteTask(event) {
    if (event.target.value === 'Yes') {

      this.isSubmitEnabled = false;
      this.reAssignYes = false;
    } else {
      if (this.reAssignYes) {
        this.isSubmitEnabled = false;
      } else {
        this.isSubmitEnabled = true;
      }
      this.completeTaskYes = false;
    }
  }

  radioReAssignTask(event) {
    if (event.target.value === 'Yes') {

      this.isSubmitEnabled = false;
    } else {
      if (this.completeTaskYes) {
        this.isSubmitEnabled = false;
      } else {
        this.isSubmitEnabled = true;
      }
      this.reAssignYes = false;
    }

  }

  searchTask() {
  console.log('searchTask()');
  if(this.dataService.getSharedDataObject().get('overdueTasks')) {
    this.taskDueDateFrom = "2015/01/01";

    this.taskSearch = new TaskSearch();
    const indvTask = new Task();
    /*if (this.taskDueDateFrom != null) {
      this.taskDueDateFrom = this.dateUtil.convertDateForServer(this.taskDueDateFrom);
    }*/

    if (this.taskDueDateTo != null) {
      this.taskDueDateTo = this.dateUtil.convertDateForServer(this.taskDueDateTo);
    }

    this.taskSearch.taskDueDateFrom = this.taskDueDateFrom;
    this.taskSearch.taskDueDateTo = this.taskDueDateTo;
    indvTask.taskStatus="OP,IP";
    this.taskSearch.task = indvTask;
    this.taskSearch.assignedTo = this.assignedTo;
    this.taskSearch.county = this.county;
    this.taskSearch.completionDtSw = this.completionDtSw;
    if (this.assignedUser === null || this.assignedUser === undefined || this.assignedUser === '') {
      this.taskSearch.task.assignedUser = null;
    }
    this.search();
    this.dataService.removeValueFromSharedDataMap('overdueTasks'); 
    console.log('Task Search overdue flag after removing from shared data: ' + this.dataService.getSharedDataObject().get('overdueTasks'));
      

    
  }
  else {

    if(this.checkFromDate() && this.checkToDate() && this.validDates()) {

      if (this.taskStatusMulti !== null && this.taskStatusMulti !== undefined && this.taskStatusMulti.length > 0) {
        this.task.taskStatus = '';
        for (const status of this.taskStatusMulti) {
          this.task.taskStatus += status.value + ',';
        }
        this.task.taskStatus = this.task.taskStatus.substring(0, this.task.taskStatus.length - 1);
      } else {
        this.task.taskStatus = null;
      }
  
        if (this.taskDueDateFrom === undefined &&
          this.taskDueDateTo === undefined &&
          this.task.taskType === undefined &&
          this.task.programCd === undefined &&
          this.task.taskStatus === undefined &&
          this.assignedTo === undefined &&
          this.county === undefined
        ) {
          this.noData = true;
          this.tasks = undefined;
        } else {
          if (!this.validDates()) {
            return;
          }
    
          
            this.taskSearch = new TaskSearch();
    
            if (this.taskDueDateFrom != null) {
              this.taskDueDateFrom = this.dateUtil.convertDateForServer(this.taskDueDateFrom);
            }
      
            if (this.taskDueDateTo != null) {
              this.taskDueDateTo = this.dateUtil.convertDateForServer(this.taskDueDateTo);
            }
      
            this.taskSearch.taskDueDateFrom = this.taskDueDateFrom;
            this.taskSearch.taskDueDateTo = this.taskDueDateTo;
            this.taskSearch.task = this.task;
            this.taskSearch.assignedTo = this.assignedTo;
            this.taskSearch.county = this.county;
            this.taskSearch.completionDtSw = this.completionDtSw;
            if (this.assignedUser === null || this.assignedUser === undefined || this.assignedUser === '') {
              this.taskSearch.task.assignedUser = null;
            }
            this.search();
         
          
          }
      
          //this.onSearchClick(event);
    }
  }
  }

  validDates() {
    console.log('validDates()');
    if(this.checkFromDate() && this.checkToDate()){

      console.log('validate dates');

      if (this.taskDueDateFrom !== undefined
        && this.taskDueDateFrom !== null
        && this.taskDueDateTo !== undefined
        && this.taskDueDateTo !== null) {
        const startDt = new Date(this.taskDueDateFrom.year,
          this.taskDueDateFrom.month - 1,
          this.taskDueDateFrom.day);
        const endDt = new Date(this.taskDueDateTo.year,
          this.taskDueDateTo.month - 1,
          this.taskDueDateTo.day);
  
        console.log('startDt: ' + startDt);
        console.log('endDt: ' + endDt);
        
        if(startDt.toString() != "Invalid Date" && endDt.toString() != "Invalid Date") {
          if (startDt > endDt) {
            this.errorEndDateField = FROMDT_GT_TODT;
            this.errorFromDateField = null;
            this.errorToDateField = null;
            console.log('display errorEndDateField: ' + this.errorEndDateField);
            return false;
          } else {
            this.errorEndDateField = null;
          }
    
          var toDate = new Date(startDt);
          toDate.setDate(toDate.getDate() + 180);
          console.log('toDate: ' + toDate);
          console.log('this.taskDueDateTo: ' + this.taskDueDateTo);
          if(endDt > toDate) {
            this.errorMoreThanSixMonthsInterval = this.errorMessageMoreThanSixMonthsInterval;
            console.log('display errorMoreThanSixMonthsInterval: ' + this.errorMoreThanSixMonthsInterval);
            this.errorFromDateField = null;
            this.errorToDateField = null;
            this.errorEndDateField = null;
            return false;
          } else {
            this.errorFromDateField = null;
            this.errorToDateField = null;
            this.errorMoreThanSixMonthsInterval = null;
          }

        } else {

          return false;
        }
		    

        return true;
    }

    } else {
		return false;
	}
    
  }

  checkFromDate() {
    //console.log('Task Search overdue flag: ' + this.dataService.getSharedDataObject().get('overdueTasks'));
    //this.taskDueDateFrom = this.data.getValueFromSharedDataMap('dashboardFromDate');
       
    if(this.dataService.getSharedDataObject().get('overdueTasks')) {
      this.taskDueDateFrom = "2015/01/01";
     // this.search();
     console.log('Task Search this.taskDueDateFrom: ' + this.taskDueDateFrom);
    } else {
     
      console.log('validate this.taskDueDateFrom : '+ this.taskDueDateFrom);
      if (this.taskDueDateFrom == undefined || this.taskDueDateFrom == null) {
        this.errorFromDateField = "Required Field";
        this.errorMoreThanSixMonthsInterval = null;
        this.errorEndDateField = null;
  
        console.log('check this.taskDueDateTo : '+ this.taskDueDateTo);
        if (this.taskDueDateTo == undefined || this.taskDueDateTo == null) {
          this.errorToDateField = "Required Field";
          this.errorMoreThanSixMonthsInterval = null;
          this.errorEndDateField = null;
        } else {
          this.errorToDateField = null;
        }
       return false;
      } else{
        this.errorFromDateField =null;
      }
    
    }

    return true;
  }

  checkToDate() {
    console.log('validate this.taskDueDateTo : '+ this.taskDueDateTo);
    if (this.taskDueDateTo == undefined || this.taskDueDateTo == null) {
        this.errorToDateField = "Required Field";
        this.errorMoreThanSixMonthsInterval = null;
        this.errorEndDateField = null;
        return false;
    } else{
      this.errorToDateField =null;
    }
    return true;
  }

  getRefTableData() {   
    /*this.programs = this.data.getValueFromSharedDataMap("PROGRAMS");
    this.taskStatus = this.data.getValueFromSharedDataMap('TASKSTATUS');
    this.taskTypes = this.data.getValueFromSharedDataMap('TASKTYPES');
    this.counties = this.data.getValueFromSharedDataMap('COUNTIES');
    this.assignedToDD = this.data.getValueFromSharedDataMap('ASSIGNEDTO');*/
    if (this.data.getValueFromSharedDataMap('PROGRAMS') !== undefined) {
      this.programs = this.data.getValueFromSharedDataMap('PROGRAMS');
      this.taskStatus = this.data.getValueFromSharedDataMap('TASKSTATUS');
      //this.taskTypes = this.data.getValueFromSharedDataMap('TASKTYPES');

      this.taskTypesCopy = this.data.getValueFromSharedDataMap('TASKTYPES');
      //this.disableTaskTypes = this.data.getValueFromSharedDataMap('DISABLETASKTYPES');
      this.taskTypes = [];
      this.taskTypesCopy.map((item, index) => {
        //console.log('value ==== ' + item.value);
        if (!(item.value === 'DC' || item.value === 'CT' || item.value === 'EI' || item.value === 'CO' || item.value === 'PD')) {          
          this.taskTypes.push(item);
        }    
        if(item.value === 'OP') {
          item.name='Other - Participant Requesting Reimbursement Status Update';          
        } else if(item.value === 'OS') {
          item.name='Other - System Support';          
        } 
      });      

      let firstElem = this.taskTypes[0];
      this.taskTypes.shift();
      this.taskTypes.sort();
            this.taskTypes.sort(function(a, b){
              var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase()
              if (nameA < nameB) //sort string ascending
                return -1
              if (nameA > nameB)
                return 1
              return 0 //default return value (no sorting)
            });
      this.taskTypes.unshift(firstElem);
      this.counties = this.data.getValueFromSharedDataMap('COUNTIES');
      this.assignedToDD = this.data.getValueFromSharedDataMap('ASSIGNEDTO');
      sessionStorage.setItem('programs', JSON.stringify(this.programs));
      sessionStorage.setItem('taskStatus', JSON.stringify(this.taskStatus));
      sessionStorage.setItem('taskTypes', JSON.stringify(this.taskTypes));
      sessionStorage.setItem('counties', JSON.stringify(this.counties));
      sessionStorage.setItem('assignedToDD', JSON.stringify(this.assignedToDD));
    } else {
      this.programs = JSON.parse(sessionStorage.getItem('programs'));
      this.taskStatus = JSON.parse(sessionStorage.getItem('taskStatus'));
      this.taskTypes = JSON.parse(sessionStorage.getItem('taskTypes'));
      this.counties = JSON.parse(sessionStorage.getItem('counties'));
      this.assignedToDD = JSON.parse(sessionStorage.getItem('assignedToDD'));
    }

    this.programMap = this.commonUtil.createMapFromList(this.programs);
    this.taskStatusMap = this.commonUtil.createMapFromList(this.taskStatus);
    this.taskTypesMap = this.commonUtil.createMapFromList(this.taskTypes);
    this.countiesMap = this.commonUtil.createMapFromList(this.counties);
    this.assignedToMap = this.commonUtil.createMapFromList(this.assignedTo);

    this.programsJson = this.commonUtil.createNativeMapFromList(this.programs);
    this.taskTypesJson = this.commonUtil.createNativeMapFromList(this.taskTypes);
    this.taskStatusJson = this.commonUtil.createNativeMapFromList(this.taskStatus);
    this.countiesJson = this.commonUtil.createNativeMapFromList(this.counties);
    this.assignedToJson = this.commonUtil.createNativeMapFromList(this.assignedTo);

    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    this.loadCounties();
  }

  /* Load user counties for task search */
  loadCounties() {
    this.countiesDropdown = [];
    if (this.countiesArr != undefined && this.countiesArr != null) {
      for (const countyArr of this.countiesArr) {
        for (const county of this.counties) {
          if (countyArr.id.serviceCounty.toString() === county.value) {
            this.countiesDropdown.push({ value: countyArr.id.serviceCounty.toString(), name: county.name });
            break;
          }
        }
      }
      this.countiesDropdown.sort(this.commonUtil.sortObjectsByStringProperty('name'));
      this.countiesDropdown.unshift({ value: undefined, name: 'Pick an Option' });
    }
  }

  clearSearch() {
    //this.taskDueDateFrom = undefined;
    //this.taskDueDateTo = undefined;
    this.taskDueDateTo = this.dateUtil.convertDateFromServer(this.dateUtil.getFormattedSystemDateFromModelForServer());
    this.taskDueDateFrom = this.dateUtil.convertDateFromServer(this.getFromDate());
    this.errorMoreThanSixMonthsInterval = null;
    this.errorFromDateField = null;
    this.errorEndDateField = null;
    this.errorToDateField = null;

    console.log('this.taskDueDateTo: ' + this.taskDueDateTo);
    console.log('this.taskDueDateFrom: ' + this.taskDueDateFrom);

    this.task.taskType = undefined;
    this.task.programCd = undefined;
    this.task.taskStatus = undefined;
  }


  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }

  getUserInfoForTaskId(task, referralId, wpPersonId, clickType) {
    this.dataService.addValueToSharedDataMap('referralId', referralId);
    this.dataService.addValueToSharedDataMap('wpPersonId', wpPersonId);
    this.http.post<any>(this.serverConstants.COMMON_SERVER_API_URL + '/personsummary/personEnrollmentSummary',
      { 'referralId': Number(referralId), 'personId': Number(wpPersonId) })
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res === null || res === undefined) {
            this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          } else {
            const personEnrollmentSummary: any = res;

            if (personEnrollmentSummary.etEnrollment !== null) {

              if (personEnrollmentSummary.etEnrollment.enrollmentEndDt != null) {
                this.dataService.makeAllPagesReadyIfCaseClosed();
              } else {
                this.dataService.revertReadOnlyChanges();
                this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
              }

              this.dataService.addValueToSharedDataMap('etEnrollment', personEnrollmentSummary.etEnrollment);
            }
            if (personEnrollmentSummary.personProvider !== null) {
              this.dataService.addValueToSharedDataMap('personProvider', personEnrollmentSummary.personProvider);
            }
            if(clickType === 'task'){
              this.navigateOnRefferalDecision(task.taskType);
            }
            else{
              this.navigateOnRefferalDecisionAudit(task.taskType);
            }
            
          }
        },
        response => {
          this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }

  updateTaskStatus(task) {
    if (task.taskStatus !== 'OP') {
      return;
    }

    this.http.post<any>(this.serverConstants.SERVER_API_URL + '/tasks/mark-as-inProgress',
      /*{'taskId': Number(task.id)}*/task.id)
      .subscribe(
        (res: HttpResponse<any>) => {

        },
        response => {
          this.notificationService.error('Task', this.userActionNotificationsMap.ERROR + ' There was an error while updating the task status.');
        },
        () => {
        });
  }

  routeSelection(task, referralId, wpPersonId) {
    //this.setInitSearchCriteria();
    this.dataService.addValueToSharedDataMap('referralId', referralId);
    this.dataService.addValueToSharedDataMap('wpPersonId', wpPersonId);
    console.log('wpPersonId ===== ' + wpPersonId);
    console.log('task.component - routeSelection - task.taskType ========== '+task.taskType);
    if (task.taskType === 'RR') {

      this.http.post<WpPerson>(this.serverConstants.COMMON_SERVER_API_URL + '/persondata/load', wpPersonId).subscribe(
        (data: WpPerson) => {
          if (data !== undefined && data.ssn !== undefined) {
            this.dataService.addValueToSharedDataMap('SSN_SEARCH', data.ssn);
            this.dataService.addValueToSharedDataMap('UNIVERSE_SEARCH', true);
            this.navigateRoute(task);
          }

        }, response => {
          //Display Toast Error Notification
          this.notificationService.error('Person', this.userActionNotificationsMap.ERROR);
        }, () => {
        });
    } 
    else if(task.taskType === 'AR') {    
      this.dataService.removeValueFromSharedDataMap('wpPerson');      
      
      this.http.post<any>(this.serverConstants.COMMON_SERVER_API_URL + "/personsummary/personEnrollmentSummary",
        { "referralId": Number(referralId), "personId": Number(wpPersonId) })
        .subscribe(
          (res: HttpResponse<any>) => {
            if (res !== null && res !== undefined) {             
              const personEnrollmentSummary: any = res;

              if (personEnrollmentSummary.etEnrrolment !== null) {
                if (personEnrollmentSummary.etEnrollment.enrollmentEndDt != null) {
                  this.dataService.makeAllPagesReadyIfCaseClosed();
                } else {
                  this.dataService.revertReadOnlyChanges();
                  this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
                }
                this.dataService.addValueToSharedDataMap("etEnrollment", personEnrollmentSummary.etEnrollment);
              }
              if (personEnrollmentSummary.personProvider !== null) {
                this.dataService.addValueToSharedDataMap("personProvider", personEnrollmentSummary.personProvider);
              }   
              
              this.dataService.removeValueFromSharedDataMap('componentObject');
              this.router.navigate(['/task/componentSummary/reviewRecommendations']);
            }
          },
          response => {            
          },
          () => {
          });
        
    } else {
      this.http.post<any>(this.serverConstants.COMMON_SERVER_API_URL + '/personsummary/personEnrollmentSummary',
        { 'referralId': Number(referralId), 'personId': Number(wpPersonId) })
        .subscribe(
          (res: HttpResponse<any>) => {
            if (res === null || res === undefined) {
              this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
            } else {
              const personEnrollmentSummary: any = res;

              if (personEnrollmentSummary.etEnrrolment !== null) {
                if (personEnrollmentSummary.etEnrollment.enrollmentEndDt != null) {
                  this.dataService.makeAllPagesReadyIfCaseClosed();
                } else {
                  this.dataService.revertReadOnlyChanges();
                  this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
                }
                this.dataService.addValueToSharedDataMap('etEnrollment', personEnrollmentSummary.etEnrollment);
              }
              if (personEnrollmentSummary.personProvider !== null) {
                this.dataService.addValueToSharedDataMap('personProvider', personEnrollmentSummary.personProvider);
              }
              this.navigateRoute(task);
            }
          },
          response => {
            this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          },
          () => {
          });
    }
  }

  navigateRoute(task) {
    switch (task.taskType) {
      case 'RF': {  // Referral
        this.router.navigate(['task/contactSummary']);
        break;
      }
      case 'AP': {  // Referral
        this.dataService.addValueToSharedDataMap('appTaskId', task.id);
        this.router.navigate(['/task/appointment']);
        break;
      }
      case 'CA': {  // Referral
        this.router.navigate(['/task/appointment']);
        break;
      }
      case 'PA': {  // Perform Assessment
        this.router.navigate(['task/assessmentSummary']);
        break;
      }
      case 'CN':  // Client Not Longer RTW
      case 'CC':  // Case Closure
      case 'CD':  // Client Dropped from SNAP Case
      case 'ER':  // Employment Plan Annual Review
      case 'EP': {  // Employment Plan
        this.dataService.addValueToSharedDataMap('taskId', task.id);
        this.router.navigate(['task/employmentPlanSummary']);
        break;
      }
      case 'CM':  // Component
      case 'CU': {  // Component Updates
        this.router.navigate(['task/componentSummary']);
        break;
      }
      case 'CH':
      case 'MT': {  // Monthly Track Component
        this.router.navigate(['task/componentSummary/trackComponent']);

        break;
      }
      case 'PR': {  // Provider Reassigment
        this.router.navigate(['task/personSummary/enrollmentSummary']);
        break;
      }
      case 'CE':
      case 'CG':
      case 'DG':
      case 'GQ':
      case 'NC':  // Non Compliance
      case 'GR':  // Good Cause Request
      case 'GD': {  // Good Cause Decision
        this.router.navigate(['/task/noncomplianceSummary']);
        break;
      }
      case 'ED': {  // Exemption Decision
        this.router.navigate(['/task/noncomplianceSummary']);
        break;
      }
      case 'CW':{
        this.router.navigate(['/task/componentSummary/comparable']);
        break;
      }
      case 'PR': {  // Provider Reassignment
        this.router.navigate(['task/personSummary']);
        break;
      }
      case 'DU':{
        this.router.navigate(['task/correspondence']);
        break;
      }
      case 'AC':  // Address Change
      case 'WR':  // Work Registration Exemption
      case 'ND':  // Non Compliance Decision
      case 'EX':  // Exemption Request
      case 'AR':  // Activity Recommendation
      case 'RR': {  // Reverse Referral
        this.dataService.addValueToSharedDataMap('task', task);
        this.router.navigate(['/universe/create']);
        break;
      }
      case 'ET':
      case 'OT': 
      case 'OS': {  // Reverse Referral
        this.dataService.addValueToSharedDataMap('task', task);
        this.router.navigate(['/task/createTask']);
        break;
      }
      case 'RQ':  // Reimbursement Request
      case 'RE':  //  Reimbursement Return for Revision (Actionable)
      case 'OP': {
        //this.router.navigate(['/task/reimbursementsSummary/reimbursements']);
        this.router.navigate(['/task/reimbursementsSummary']);
        break;
      }
      
      case 'RP':  //  Reimbursement Paid (Informational)
      case 'RA': {  //  Reimbursement Decision
        this.router.navigate(['/task/reimbursementsSummary']);
        break;
      }
      case 'RR': {  // Reverse Referral
        this.router.navigate(['/universe/personSummary']);
        break;
      }
      case 'EC': {  // Employment Change
        this.router.navigate(['task/assessmentSummary']);
        break;
      }
      case 'TC': {  // Contact Change
        this.router.navigate(['task/personSummary']);
        break;
      }
    }
  }

  elasticSearch(searchQuery, results) {
    const countiesArr = this.dataService.getSharedDataObject().get('userCounties');
    let providerId = this.dataService.getSharedDataObject().get('providerId');
    let countiesStr = '';

    if (countiesArr !== undefined && countiesArr !== null) {
      for (const c of countiesArr) {
        countiesStr += c.id.serviceCounty + ',';
      }
      countiesStr.substring(0, countiesStr.length - 2);
    }
    searchQuery = searchQuery.replace(new RegExp('/', 'g'), '');

    if (providerId === null || providerId === undefined) { providerId = 0; }

    if (countiesStr !== undefined && providerId !== undefined) {

      this.http.post(this.serverConstants.COMMON_SERVER_API_URL + '/search/person/', {text: searchQuery, counties: countiesStr, providerId: providerId}).subscribe(
        (val: any[]) => {
          this.valArray = val;
          if (this.valArray === null || this.valArray === undefined || this.valArray.length === 0) {
            this.noData = true;
          }
          results.next(val);

        },
        response => {
          this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          results.next(null);
        }
      );
    }
  }

  getSuggestions(event) {
    if (this.currentSearch.length < MIN_CHAR_SEARCH_LENGTH) {
      this.noData = false;
    }
    if (this.currentSearch.length >= MIN_CHAR_SEARCH_LENGTH) {
      event.srcElement.blur();
      event.preventDefault();
      this.elasticSearch(this.currentSearch, this.elasticSuggestions);
      this.elasticSuggestions.subscribe((value) => {
        this.suggestions = value;
      });
    } else {
      this.suggestions = [];
    }
  }

  autoCompleteResultClick(result) {
    this.loaderIndivFocus = false;
    this.currentSearch = result.firstName + ' ' + result.lastName;
    this.results = [];
    for (const s of this.suggestions) {
      if (s.id === result.id) {
        this.results.push(Object.assign({}, s));
        this.dataService.addValueToSharedDataMap('elasticSearchIndvId', result.id);
        break;
      }
    }
    this.suggestions = [];
    this.elasticSuggestions.next(null);
    this.tasks = undefined;
  }

  goToEnrollmentSummary(result) {
    //this.setInitSearchCriteria();
    this.dataService.addValueToSharedDataMap('referralId', result.referralId);
    this.dataService.addValueToSharedDataMap('wpPersonId', result.personId);
    if (result.ssn !== undefined && result.ssn.length === 9) {
      this.dataService.addValueToSharedDataMap('SSN_SEARCH', result.ssn);
    }

    this.http.post<any>(this.serverConstants.COMMON_SERVER_API_URL + '/personsummary/personEnrollmentSummary',
      { 'referralId': Number(result.referralId), 'personId': Number(result.personId) })
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res === null || res === undefined) {
            this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          } else {
            const personEnrollmentSummary: any = res;

            if (personEnrollmentSummary.etEnrollment !== null) {
              if (personEnrollmentSummary.etEnrollment.enrollmentEndDt != null) {
                this.dataService.makeAllPagesReadyIfCaseClosed();
              } else {
                this.dataService.revertReadOnlyChanges();
                this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
              }
              this.dataService.addValueToSharedDataMap('etEnrollment', personEnrollmentSummary.etEnrollment);
            }
            if (personEnrollmentSummary.personProvider !== null) {
              this.dataService.addValueToSharedDataMap('personProvider', personEnrollmentSummary.personProvider);
              /*let setproviderId = personEnrollmentSummary.personProvider.id.providerId;
              this.dataService.addValueToSharedDataMap('providerId', setproviderId);*/
            }
            this.router.navigate(['/task/personSummary']);
          }
        },
        response => {
          this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }

  searchTasksForIndv(selected) {
    const person = new WpPerson();
    const referral = new WpReferral();
    const indvTask = new Task();
    this.taskSearch = new TaskSearch();

    person.id = selected.personId;
    referral.id = selected.referralId;
    indvTask.wpPerson = person;
    indvTask.wpReferral = referral;
    this.taskSearch.task = indvTask;
    this.dataService.addValueToSharedDataMap("taskSearch", this.taskSearch);
    this.search();
  }

  search() {
    this.http.post<TaskSearch>(this.serverConstants.SERVER_API_URL + '/tasks/search', this.taskSearch).subscribe(
      (val) => {
        if (val == null || val.hasOwnProperty('errorCode')) {
          this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          setTimeout(() => this.taskStartDtDp.nativeElement.focus(), 0);
          this.taskStartDtDp.nativeElement.click();
          return;
        }
        this.taskSearch = val;

        if (this.taskSearch.taskDueDateFrom != null) {
          this.taskDueDateFrom = this.dateUtil.convertDateFromServer(this.taskSearch.taskDueDateFrom);
        }

        if (this.taskSearch.taskDueDateTo != null) {
          this.taskDueDateTo = this.dateUtil.convertDateFromServer(this.taskSearch.taskDueDateTo);
        }
        if (this.taskSearch.tasks !== null && this.taskSearch.tasks.length > 0) {
          this.tasks = this.taskSearch.tasks;
          this.noData = false;
        } else {
          this.tasks = undefined;
          this.noData = true;
        }
         this.tasksCorrected = JSON.parse(JSON.stringify(this.taskSearch.tasks));
        this.tasksCorrected.forEach(element => {
          const taskStatusMap = this.taskStatusJson;
          const taskStatusCode = element.taskStatus;
          const taskStatus = taskStatusMap[taskStatusCode];
          const taskTypesMap = this.taskTypesJson;
          const taskTypeCode = element.taskType;
          const taskType = taskTypesMap[taskTypeCode];
          element.taskType=taskType;
          element.taskStatus=taskStatus;
          let assUser="";
          if (element.assignedToInd === "C") {
          assUser= element.assignedUserStr;
           } else if (element.assignedToInd === "P") {
           assUser = this.providers.get(element.assignedTo);
           }
          element.assignedTo=assUser;
          element.createdDate=this.dateUtil.convertDateFromServerForExcelPDF(element.createdDate.trim().split('T')[0]);
          if(element.taskCompletionDt ==  null)
           {
            element.taskCompletionDt = ' ';
            }
            else
           {
            element.taskCompletionDt = this.dateUtil.convertDateFromServerForExcelPDF(element.taskCompletionDt)
            }
          element.serviceCounty=this.countiesMap.get(element.serviceCounty + '');
    });
        this.completionDtSw = 'N';
      },
      response => {
        this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  getTaskHistory(taskId, taskStatus) {
    this.isTaskInprogress = false;
    this.isTaskOpen = false;
    if (taskStatus === 'OP') {
      this.isTaskOpen = true;
    }
    if (taskStatus === 'IP') {
      this.isTaskInprogress = true;
    }
    this.historyTasks = [];
    this.taskHistory = null;
    this.reAssignYes = false;
    this.completeTaskYes = false;
    this.reAssignNo = false;
    this.completeTaskNo = false;
    this.isSubmitEnabled = true;
    this.http.get<TaskHistory[]>(this.serverConstants.SERVER_API_URL + '/audits/entity/changes/id', {
      params: {
        entityType: 'wr.dc.wp.model.TasksEntity',
        entityId: taskId,
        limit: '5'
      }
    }).subscribe(
      (val: TaskHistory[]) => {
        this.taskHistory = val;

        this.modifyTaskHistoryResults();
        this.getWorkers();
      },
      response => {
        this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  getWorkers() {
    this.http.get<any[]>(this.serverConstants.SERVER_API_URL + '/users', {}).subscribe(
      (val: any[]) => {
        this.workers = val;
      },
      response => {
        this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  modifyTaskHistoryResults() {

    if (this.taskHistory.length > 0) {
      for (let i = 0; i < this.taskHistory.length; i++) {
        const taskObj = JSON.parse(this.taskHistory[i].entityValue);
        this.historyTasks[i] = taskObj;
        this.firstHistoryTask = taskObj;
        this.historyTasks[i].lastModifiedBy = this.taskHistory[i].modifiedBy;

      }
      this.noHistoryData = false;
    } else {
      this.firstHistoryTask = undefined;
      this.historyTasks = undefined;
      this.noHistoryData = true;
    }
  }

  openDialog(content, taskId, taskStatus) {
    this.getTaskHistory(taskId, taskStatus);
    this.modalReference = this.modalService.open(content, { centered: true, size: 'lg' });
    this.modalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  completeTask(taskId) {
    this.http.post<Task>(this.serverConstants.SERVER_API_URL + '/tasks/mark-as-complete', {
      taskId: this.firstHistoryTask.id,
      isCompleteTask: this.completeTaskYes, isReAssign: this.reAssignYes, username: this.reAssignedWorker
    }).subscribe(
      (val) => {
        if (val.id === this.firstHistoryTask.id) {
          this.getTaskHistory(taskId, null);
        }
      },
      response => {
        this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });

  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  setInitSearchCriteria() {
    this.dataService.addValueToSharedDataMap('taskDueDateFrom', this.taskDueDateFrom);
    this.dataService.addValueToSharedDataMap('taskDueDateTo', this.taskDueDateTo);
    this.dataService.addValueToSharedDataMap('taskType', this.task.taskType);
    this.dataService.addValueToSharedDataMap('programCd', this.task.programCd);
    this.dataService.addValueToSharedDataMap('taskStatus', this.task.taskStatus);
    this.dataService.addValueToSharedDataMap('initTaskSearchSw', 'Y');
    this.dataService.addValueToSharedDataMap('searchCriteria', this.searchCriteria);
    this.dataService.addValueToSharedDataMap('currentSearch', this.currentSearch);
    this.dataService.addValueToSharedDataMap('assignedTo', this.assignedTo);
    this.dataService.addValueToSharedDataMap('county', this.county);
  }

  initTaskSearch() {

  }

  configDatePicker() {
    this.minDate = this.taskDueDateFrom;

  }

  getUserSuggestions(event:KeyboardEvent) {
    this.suggestionsUser = [];
    if (this.assignedUser.length >= MIN_CHAR_SEARCH_LENGTH) {
      (event.srcElement as HTMLElement).blur();
      event.preventDefault();
      this.elasticUserSearch(this.assignedUser, this.elasticSuggestionsUser);
      this.elasticSuggestionsUser.subscribe((value) => {
        this.suggestionsUser = value;
      });
    } else {
      this.suggestionsUser = [];
    }
  }

  elasticUserSearch(searchQuery, results) {
    const fullName =  this.assignedUser;
    const providerId = null;
    const serviceCounties = [];

    if (this.county !== null && this.county !== undefined) {
      serviceCounties.push(this.county);
    } else {
      if (this.countiesArr !== undefined && this.countiesArr !== null) {
        for (const countyArr of this.countiesArr) {
          serviceCounties.push(countyArr.id.serviceCounty);
        }
      }
    }

    this.http.post(this.serverConstants.SERVER_API_URL + '/es-user/search/', {fullName: fullName, providerId: providerId, serviceCounties: serviceCounties}).subscribe(
      (val) => {
        results.next(val);
      },
      response => {
        this.notificationService.error('Users', this.userActionNotificationsMap.ERROR);
        results.next(null);
      }
    );
  }

  autoCompleteUserClick(user) {
    this.assignedUser = user.firstName + ' ' + user.lastName;
    this.task.assignedUser = user.id;
    this.suggestionsUser = [];
    this.elasticSuggestionsUser.next(null);
  }

  autoCompleteUserKeydown(event, user) {
    if ( (!event.shiftKey && event.keyCode) === 9 || event.keyCode === 32 || event.keyCode === 13) {
      this.assignedUser = user.firstName + ' ' + user.lastName;
      this.task.assignedUser = user.id;
      this.suggestionsUser = [];
      this.elasticSuggestionsUser.next(null);
    }
  }

  loadProviders() {
    this.providers = new Map<any, string>();
    this.providerService.findAllProvidersList().subscribe(
      (res: any) => {
        const providersLst: WpProvider[] = res;

        if (providersLst !== undefined && providersLst !== null && providersLst.length !== 0) {
          for (const p of providersLst) {
            this.providers.set(p.id, p.providerName);
          }
          this.dataService.addValueToSharedDataMap('providers', this.providers);
        }
      }, (res: HttpErrorResponse) => {
        this.notificationService.error('Providers', this.userActionNotificationsMap.ERROR);
      }, () => {
      }
    );
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
    setTimeout(function() {
      params.api.resetRowHeights();
    }, 0);
  }

  onGridReadyIndv(params) {
    this.gridApiIndv = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridOptions.columnDefs = this.columnDefs;
    } else {
      this.gridApi.sizeColumnsToFit();
      this.gridApiIndv.sizeColumnsToFit();
    }
  }

  ngOnDestroy() {
    this.taskStatusMulti = [];
  }


  closeFix(event, datePicker) {
    if (event.target.offsetParent == null) {
      datePicker.close();
    } else if (event.target.offsetParent.nodeName != 'NGB-DATEPICKER') {
      datePicker.close();
         }
  }

  /* For Task Search */

  /* For Individual Search*/



  focusNextFromIndvSearch(e) {
    if (!this.noData) {
      if (this.suggestions !== null && this.suggestions !== undefined && this.suggestions.length > 0) {
        this.addEventListenerToIndvSearch(e);
      } else {
        /*if (e.keyCode === 9 && !e.shiftKey && !this.noData) {
          e.preventDefault();
          setTimeout(() => this.headerText.nativeElement.focus(), 0);
          this.headerText.nativeElement.click();
        }*/
      }
    } else {
    }
  }

  focusSearchInput(e) {
    setTimeout(() => this.searchInput.nativeElement.focus(), 0);
  }


  addEventListenerToIndvSearch(event) {
    const tabKeyCode = 9;
    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.results.length === 0) {
      return;
    }
    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }
    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndexIndv();
  }

  setDisplayedRowAtIndexIndv() {
    // get the first row
    const rowNode = this.gridApiIndv.getDisplayedRowAtIndex(0);
    // scrolls to the first row
    //this.gridApiIndv.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApiIndv.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApiIndv.setFocusedCell(0, firstCol);
  }


  /* For Task Search*/
  focusSearchSummary(e) {
    this.firstTime = false;
    this.addEventListenerToButton(e);
  }


  focusIndividualSearch(e) {
    this.addEventListenerToButton(e);
  }

  addEventListenerToButton(event) {
    const tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }

    if (this.tasks.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row

    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  /* Go To Header*/

  focusing(event) {
    if (!event.shiftKey && event.keyCode == 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  onPaginationChanged() {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  onPaginationChangedIndv() {
    if (this.gridApiIndv) {
      this.setDisplayedRowAtIndexIndv();
    }
  }
  filter(event){
    this.firstTime = true;
  }

  onAssignUserChange(event) {
    this.loaderUserFocus = true;
    this.loaderIndivFocus = false;
    this.loaderSearchFocus = false;
    this.loaderPfdFocus = false;
    event.srcElement.blur();
    event.preventDefault();
  }

  onSearchChange(event) {
    if( event.keyCode === 32 || event.keyCode === 13) {
      this.loaderUserFocus = false;
      this.loaderIndivFocus = false;
      this.loaderSearchFocus = true;
      this.loaderPfdFocus = false;
      event.srcElement.blur();
      event.preventDefault();
      this.searchTask();
    } else if ( !event.shiftKey && event.keyCode === 9 ) {
      this.loaderSearchFocus = false;
    }
  }

  onSearchClick(event) {
      this.loaderUserFocus = false;
      this.loaderIndivFocus = false;
      this.loaderSearchFocus = true;
      this.loaderPfdFocus = false;
      event.srcElement.blur();
      event.preventDefault();
      //this.searchTask();
  }


  onIndivUserChange(event) {
    this.loaderUserFocus = false;
    this.loaderIndivFocus = true;
    this.loaderSearchFocus = false;
    this.loaderPfdFocus = false;
    event.srcElement.blur();
    event.preventDefault();
  }

  gridClick() {
    this.firstTime = false;
  }

  individualFocus() {
    this.loaderIndivFocus = true;
  }

  focusPdfIcon(event){
    this.loaderUserFocus = false;
    this.loaderIndivFocus = false;
    this.loaderSearchFocus = false;
    this.loaderPfdFocus = true;
    event.srcElement.blur();
    event.preventDefault();
  }

  getFromDate() {

    const fromDt = new Date(new Date().getTime() - 180 * 24 * 60 * 60 * 1000);
    console.log('from date: ' + fromDt);
    const dd = fromDt.getDate();
    const mm = fromDt.getMonth() + 1; //January is 0!
    let ddString;
    let mmString;
    const yyyy = fromDt.getFullYear();

    if (dd < 10) {
      ddString = '0' + dd
    } else {
      ddString = '' + dd
    }

    if (mm < 10) {
      mmString = '0' + mm
    } else {
      mmString = '' + mm
    }
    console.log('fromDate:' + yyyy + '/' + mmString + '/' + ddString);

    return yyyy + '/' + mmString + '/' + ddString

  }
}



// WEBPACK FOOTER //
// ./src/app/task/task.component.ts